import * as React from 'react'
import { Avatar, Breadcrumbs, ExportButton, Tools } from './components'

import { Project } from '@aninix-inc/model'
import { CopyLink } from './components/copy-link'
import { Remix } from './components/remix'

type DivProps = React.HTMLAttributes<HTMLDivElement>

const LeftControls: React.FCC<DivProps> = ({ children, className }) => (
  <div className={className}>{children}</div>
)
const CenterControls: React.FCC<DivProps> = ({ className, children }) => (
  <div className={className}>{children}</div>
)
const RightControls: React.FCC<DivProps> = ({ children, className }) => (
  <div className={className}>{children}</div>
)

export interface IProps {
  project: Project
}

export const Toolbar: React.FCC<IProps> = ({ project, children }) => {
  /*use this to declare any global variables for toolbar*/
  const toolbarCssVariablesStyle = {
    '--toolbar-height': '48px',
    '--toolbar-bg': '#0B1118D9',
  } as React.CSSProperties

  return (
    <div
      style={toolbarCssVariablesStyle}
      className="relative flex w-full flex-col items-center bg-[--toolbar-bg] px-2 sm:flex-row sm:justify-between sm:px-4"
    >
      <div className="flex h-[--toolbar-height] w-full flex-row justify-between">
        <LeftControls className="flex items-center gap-2">
          <Avatar />
          <Tools />
        </LeftControls>

        <RightControls className="flex items-center gap-2">
          {children}
          {/* @TODO: replace export with new one */}

          <CopyLink projectId={project.id} />
          <Remix projectId={project.id} />
          <ExportButton />
        </RightControls>
      </div>

      <CenterControls className="pointer-events-none inline w-full items-center justify-center pb-4 pt-1 sm:absolute sm:inset-0 sm:flex sm:p-0">
        <div className="pointer-events-auto">
          <Breadcrumbs />
        </div>
      </CenterControls>
    </div>
  )
}

Toolbar.displayName = 'Toolbar'
